module.exports = __webpack_public_path__ + "media/images/members/veronica_casais_vila-21ef0ba12cf17c94a667712e4bb1b558.jpg";